import { CSSProperties } from "react";
import { useNavigate } from "react-router";
import { Game } from "../types";

interface GameListItemProps {
    game: Game
}

export default function GameListItem(props: GameListItemProps) {
    let game = props.game
    let slug = game.title.toLowerCase().replace(/ /g, "-")

    let navigate = useNavigate();

    return <div style={styles.container} onClick={() => navigate(`/games/${slug}`)}>
        <img src={`/images/games/${slug}/1.png`} style={styles.image} alt={`${slug}-1`} />
        <h4 style={styles.title}>{game.title}</h4>
    </div>
}

const styles: { [key: string]: CSSProperties } = {
    container: {
        position: 'relative' as 'relative',
        width: 350,
        height: 200,
        cursor: "pointer"
    },
    image: {
        borderRadius: 20,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    title: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: 'white',
        fontSize: 24,
        textShadow: '1px 1px 4px rgba(0, 0, 0, 0.7)',
        textAlign: 'center',
        fontWeight: 'bold',
    },
}